import { gql } from "@apollo/client";

export const FLEET = gql`
    query Fleet($culture: String!, $status: Status!) {
        fleet(orderBy: {createdUtc: ASC}, where: {localization: {culture: $culture}}, status: $status) {
            wingspan
            length
            maxRange
            maxTakeoffWeight
            businessSeatsMax
            businessSeatsMin
            economySeatsMin
            economySeatsMax
            icaoCode
            height
            count
            displayText
            fleetVisible
            vector {
                paths(first: 1)
            }
            cabinView {
                paths(first: 1)
            }
            cockpitView {
                paths(first: 1)
            }
            exteriorView {
                paths(first: 1)
            }
        }
    }
`;

export const FLEET_SEATMAP = gql`
    query FleetSeatMap($createdUtc: OrderByDirection = ASC, $culture: String!, $status: Status!) {
        fleet(
            where: {localization: {culture: $culture}},
            orderBy: {createdUtc: $createdUtc},
            status: $status
        ) {
            displayText
            fleetVisible
            businessSeatsMax
            businessSeatsMin
            economySeatsMin
            economySeatsMax
            seatMap {
                paths(first: 1)
            }
        }
    }
  `;
